import { render, staticRenderFns } from "./NewsDetailsFour.vue?vue&type=template&id=62fb9de8"
import script from "./NewsDetailsFour.vue?vue&type=script&lang=js"
export * from "./NewsDetailsFour.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsFour.vue?vue&type=style&index=0&id=62fb9de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports